// src/lib/chunkReload.ts - recover from stale lazy chunks after a deploy
//
// A tab opened before a deploy still references the old hashed chunk names
// (e.g. ClientRoutes-<hash>.js), which no longer exist, so lazy() rejects with
// "Failed to fetch dynamically imported module" (Sentry NEXUS-Y). Vite fires
// `vite:preloadError` for these; reloading picks up the new index.html.
// The reload happens at most once per RELOAD_WINDOW_MS so a chunk that is
// genuinely missing surfaces as an error instead of a reload loop.

const STORAGE_KEY = "nexus:chunk-reload-at";
const RELOAD_WINDOW_MS = 10_000;

export function shouldReloadForStaleChunk(
  storage: Pick<Storage, "getItem" | "setItem">,
  now: number,
): boolean {
  const last = Number(storage.getItem(STORAGE_KEY) ?? 0);
  if (now - last < RELOAD_WINDOW_MS) return false;
  storage.setItem(STORAGE_KEY, String(now));
  return true;
}

export function installChunkReloadHandler(): void {
  window.addEventListener("vite:preloadError", (event) => {
    let reload = false;
    try {
      reload = shouldReloadForStaleChunk(window.sessionStorage, Date.now());
    } catch {
      // sessionStorage unavailable: let the error boundary handle it.
    }
    if (reload) {
      event.preventDefault();
      window.location.reload();
    }
  });
}
